import React from "react";
import PageHero from "../components/PageHero";
import { Quote } from "lucide-react";

const stories = [
  {
    name: "Sachin", course: "Tool & Die (Mechanical)",
    img: "https://kikicentre.com/wp-content/uploads/2022/03/Sachin1-300x300.jpg",
    heading: "Sports & culture at Kiki",
    text: "Usually when you take admission in a technical training institute, it's just you, machines and books. But at Kiki I found we can also enjoy cultural and sports programs — open not only to students but staff too. There are events like the 100m race, hurdles, wheel barrow and the Soap Box Run we prepare for a month in advance. We celebrate our Annual Sports Day every February with snacks, medals and cakes for the winners. Enjoyment can be felt on the field!",
  },
  {
    name: "Gurjeet Singh", course: "Mechatronics", company: "Atma Autotech Engineers Pvt. Ltd.",
    img: "https://kikicentre.com/wp-content/uploads/2022/03/Gurjeet-Singh-300x300.jpg",
    heading: "On-the-Job Training through Kiki",
    text: "I feel really proud to be part of Kiki Centre for Technology. Kiki provides excellent training in soft skills and technical education which helped a lot during the various stages of my interview. Sophisticated infrastructure, excellent faculty and well-maintained labs provide every student an opportunity to excel in life.",
  },
  {
    name: "Jeslin Mathew", course: "Tool & Die (Mechanical)",
    img: "https://kikicentre.com/wp-content/uploads/2022/03/Jeslin-Mathew-300x300.jpg",
    heading: "The importance of Soft Skills",
    text: "When I joined Kiki, I was introduced to a very new subject — 'Soft Skills'. It turned out to be the most interesting and useful subject. We were trained in everything from how to sit properly to effective communication, leadership and teamwork through exercises and games. Soft skills play a very significant role in one's success and should be taught in every institute.",
  },
  {
    name: "Arun Kumar", course: "Mechatronics (Lateral Entry)", company: "IFB Industries Ltd., Bangalore",
    img: "https://kikicentre.com/wp-content/uploads/2022/03/Arun-Kumar-300x300.jpg",
    heading: "Advantage of a Kiki Diploma",
    text: "Before joining Kiki I had done a regular diploma but was depressed about my future as I couldn't find a suitable job. I joined Kiki as a lateral-entry 2nd-year student and quickly realized the trainers are very knowledgeable and helpful. During Earn While You Learn I worked at Atma, and on completion I received a job offer from IFB Bangalore at 3.5 LPA. I am very happy — thank you Kiki!",
  },
  {
    name: "Kanwaljeet Singh", course: "Tool & Die (Mechanical)",
    img: "https://kikicentre.com/wp-content/uploads/2022/03/kanwarjeet-300x300.jpg",
    heading: "Learning German at Kiki",
    text: "I have the privilege of learning the German language here, taught by specialised faculty Dr.-Ing. Wolfgang Eckhardt from Germany. As our course is certified by the German Chamber of Skilled Crafts, Koblenz, we can apply for jobs in Europe and learning German gives us an advantage — provided free of cost. Danke!",
  },
  {
    name: "Ashish Singh", course: "Tool & Die (Mechanical)", company: "Boston Scientific (Intern)",
    img: "https://kikicentre.com/wp-content/uploads/2023/05/Ashish-Singh-300x300.jpg",
    heading: "My First Day of Internship",
    text: "Today was my first day at Boston Scientific as an intern. I'm now part of the DA (Design Assurance) Lab team that tests pre-designed medical equipment. I saw so many precise machines for testing catheters. It's a great feeling to get an internship in this multinational company. Thank you Kiki for this great opportunity!",
  },
  {
    name: "Brijesh Goel", course: "Tool & Die (Mechanical)",
    img: "https://kikicentre.com/wp-content/uploads/2023/05/Brijesh-Goel-300x300.jpg",
    heading: "Learning Leadership at Kiki",
    text: "I was appointed Head Organiser of our institute's Musical Night — a theatre programme with around a hundred people. I distributed work, arranged transportation, food, lighting, audio and seating, and even co-hosted the show. There were hiccups, but we put in quick corrective measures. Overall the event was a great success and I learned a lot about leadership.",
  },
  {
    name: "Meena Netam", course: "Mechatronics",
    img: "https://kikicentre.com/wp-content/uploads/2023/05/Meena-Netam-1-300x300.jpg",
    heading: "Industrial Visit to Siegwerk",
    text: "It was a dream come true when a trip to Siegwerk India was scheduled as an industrial learning activity. The officials explained the importance of Mechatronics and its application in industry, and showed us how packaging ink is manufactured. They encouraged us to study thoroughly to get into the best industries. It will be one of the most memorable days of my life.",
  },
];

export default function StudentSpeakPage() {
  return (
    <div data-testid="student-speak-page">
      <PageHero
        path="student-speak.hero"
        kicker="Student Speak"
        title="In our students' own words"
        subtitle="Real stories from Kiki students and alumni about their learning, internships, placements and campus life."
      />
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-8">
          {stories.map((s) => (
            <div key={s.name} className="relative bg-white rounded-2xl p-7 shadow-sm border border-slate-100" data-testid={`story-${s.name.toLowerCase().replace(/\s+/g, "-")}`}>
              <Quote className="absolute top-6 right-6 h-8 w-8 text-yellow-400/40" />
              <div className="flex items-center gap-4 mb-4">
                <img src={s.img} alt={s.name} className="h-16 w-16 rounded-full object-cover border-2 border-yellow-400" />
                <div>
                  <h3 className="font-bold text-[#0B2A6B]">{s.name}</h3>
                  <p className="text-xs text-slate-500">{s.course}</p>
                  {s.company && <p className="text-xs text-yellow-600 font-semibold">{s.company}</p>}
                </div>
              </div>
              <h4 className="text-sm font-bold text-[#0B2A6B] mb-2">{s.heading}</h4>
              <p className="text-sm text-slate-600 leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
